var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThunderbolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    clipRule: "evenodd",
    viewBox: "0 0 276 512.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 257.35 44.98 0h215.18l-93.73 191.42H276L132.56 371.74c12.54 3.81 26.09 7.01 41.71 9.68 11.86 2.65 15.26 14.32 6.35 22.96l-122.94 96.7c-6.81 5.35-14.35 13.07-23.85 11.19-5.87-1.17-9.72-6.19-9.8-13.34l-2.36-136.01-.33-19.11c.16-7.5 2.96-12.13 7.18-14.08 3.43-1.58 7.79-1.41 12.43.43 12.87 6.81 24.37 12.91 35.33 18.39l21.41-91.2H0z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderbolt);
export default __webpack_public_path__ + "static/media/thunderbolt.b09723ec.svg";
export { ForwardRef as ReactComponent };